// Common site constants
export const SITE = {
  name: "IMOTEpS",
  fullName: "Institut Marseillais d'Orthopédie, de Traumatologie et de l'Épaule du Sportif",
  doctor: "Dr Richard ASWAD",
  // Téléphone principal pour la prise de rendez-vous (consultations)
  phone: "+33 4 88 60 02 16",
  phoneHref: "tel:+33488600216",
  // Téléphone direct de l'assistante Fabienne
  assistantName: "Fabienne",
  assistantPhone: "+33 4 88 60 02 15",
  assistantPhoneHref: "tel:+33488600215",
  assistantEmail: "fabienne.imoteps13@gmail.com",
  assistantEmailHref: "mailto:fabienne.imoteps13@gmail.com",
  // Email personnel du Dr Richard Aswad
  email: "raswad@wanadoo.fr",
  emailHref: "mailto:raswad@wanadoo.fr",
  address: "118 Rue Jean Mermoz, 13008 Marseille",
  doctolibUrl: "https://www.doctolib.fr/chirurgien-orthopediste/marseille/richard-aswad",
  logo: "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/qilc77hi_logo%20imoteps.png",
  portrait: "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/nj14ab15_photo%20ricky%20bureau.png",
  sportImages: [
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/yf0exdgq_accident%201.jpg",
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/7nk1ic4m_accident%203.jpg",
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/l9n2rkw5_accident%204.jpg",
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/07tty2on_accident%205.jpg",
  ],
  blocImages: [
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/dw1tn0xd_bloc%20op%C3%A9%201.jpg",
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/z7jfhm6y_bloc%20op%C3%A9%202.jpg",
    "https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/v57pzpv8_bloc%20op%C3%A9%203.jpg",
  ],
};

// Key stats for Hero
export const STATS = [
  { value: "25+", labelKey: "statExperience" },
  { value: "8000+", labelKey: "statInterventions" },
  { value: "40+", labelKey: "statPublications" },
];

// Gallery images (anonymized placeholder - will be replaced with real cases)
export const GALLERY = [
  {
    id: "g1",
    before: "https://images.unsplash.com/photo-1716996642036-2d62f3440466?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.unsplash.com/photo-1768140500459-dd312549fdb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    title_fr: "Prothèse d'épaule inversée",
    title_en: "Reverse shoulder prosthesis",
    category: "shoulder",
  },
  {
    id: "g2",
    before: "https://images.unsplash.com/photo-1716996642036-2d62f3440466?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.unsplash.com/photo-1617759383974-088ce2f5eb35?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    title_fr: "Ligamentoplastie du poignet",
    title_en: "Wrist ligament reconstruction",
    category: "hand",
  },
  {
    id: "g3",
    before: "https://images.unsplash.com/photo-1768140500459-dd312549fdb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.unsplash.com/photo-1761286753856-2f39b4413c1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    title_fr: "Arthroscopie du coude",
    title_en: "Elbow arthroscopy",
    category: "elbow",
  },
];

// Trust / institution badges
export const AFFILIATIONS = [
  "SOFCOT",
  "SOFEC",
  "SFA",
  "SECEC",
  "Mayo Clinic",
  "University of Toronto",
  "HAS",
  "CARMF",
];
